import React from 'react';

interface SectionHeadingProps {
    title: string;
    hint?: string;
}

export const SectionHeading = ({ title, hint }: SectionHeadingProps) => (
    <div>
        <p className="text-sm font-semibold">{title}</p>
        {hint && <p className="text-sm text-muted-foreground">{hint}</p>}
    </div>
);
